import PropTypes from 'prop-types';

// Inputs to model
export const InputType = PropTypes.shape({
  name: PropTypes.string,
  value: PropTypes.number, // switch to boolean vs number vs floats etc in future
});

export const ModalSplitType = PropTypes.shape({
  name: PropTypes.string.isRequired,
  value: PropTypes.number.isRequired,
});

export const ScenariosProjection = PropTypes.shape({
  bau: PropTypes.number,
  primary: PropTypes.number,
  secondary: PropTypes.number
});

// Scenarios create projections for particular years
export const ProjectionType = {
  projectionYear: PropTypes.number.isRequired,
  population: PropTypes.number.isRequired,
  gdp: PropTypes.number.isRequired,

  goals: PropTypes.object, // fill this out later
  scenarioKey: PropTypes.string.isRequired,

  // Environmental Variables
  modalSplit: PropTypes.arrayOf(ModalSplitType).isRequired,
  pm25Emissions: PropTypes.number.isRequired,
  co2Emissions: PropTypes.number.isRequired,
  vehicleDistanceTraveled: ScenariosProjection.isRequired,
  passengerDistanceTraveled: ScenariosProjection.isRequired,
}

export default {};



// WEBPACK FOOTER //
// ./src/proptypes/index.js